import { registerTypeList } from "@/views/pages/register/RegisterTypeInfo.js";

// 작성자 구분(직영/사내수급/사외수급) 검색에 사용하는 회원 meta.registerType 값
const 사내담당자 = registerTypeList.find((e) => e.key === "사내수급업체문서담당자").value;

// 직영 판정용 업체 id (author.company_id 조건으로 전달)
// 914: 본사 / 915: 각 공장 및 연구소(안전환경팀) / 916: 관리감독자 / 917: 본사, 각 공장 및 연구소(일반직원)
// 수급업체는 직영 업체 이후에 등록되어 author.company_id > 917 로 판별한다.
const 직영업체Ids = [914, 915, 916, 917];
const 직영업체MaxId = Math.max(...직영업체Ids);

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "TBM 실시일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-select",
        label: "TBM 상태",
        value: "TBM상태",
        query: { s1: "select" },
        options: {
          items: [{ text: "전체", value: "" }, "완료", "미진행"],
          default: "",
          gridTemplateColumns: "auto 100px",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "TBM 실시일", "폭염작업여부", "상태"] },
      },
      // 작성자 구분을 다음 줄에 배치하기 위한 줄바꿈 처리 (관리자 전용)
      { component: "empty-space", options: { visibleAdminOnly: true } },
      {
        component: "search-check-group",
        label: "작성자 구분",
        value: "writerType",
        query: { ck_l: "checkList" },
        options: {
          visibleAdminOnly: true,
          list: [
            { text: "전체", value: "전체" },
            { text: "직영", value: "직영" },
            { text: "사내수급", value: "사내수급" },
            { text: "사외수급", value: "사외수급" },
          ],
          selectMaxCount: 1,
          default: ["전체"],
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date && (search.date.startDate || search.date.endDate)) {
      if (search.date.startDate) {
        conditions.push({ key: "body.TBM정보.TBM실시일", operator: ">=", value: search.date.startDate });
      }
      if (search.date.endDate) {
        conditions.push({ key: "body.TBM정보.TBM실시일", operator: "<", value: new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") });
      }
    } else {
      const today = new Date().format("yyyy-MM-dd");
      conditions.push({ key: "body.TBM정보.TBM실시일", operator: ">=", value: today });
      conditions.push({ key: "body.TBM정보.TBM실시일", operator: "<", value: new Date(today).addDays(1).format("yyyy-MM-dd") });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    // TBM 상태
    if (search.TBM상태) {
      conditions.push({ key: "body.TBM상태", operator: "=", value: search.TBM상태 });
    }

    // 작성자 구분
    // - 직영 : 작성자 소속(author.company_id)이 직영 업체(본사/공장/연구소/관리감독자)인 문서
    // - 사내수급 : 수급업체 소속(author.company_id > 917) 이면서 registerType = 사내담당자
    // - 사외수급 : 수급업체 소속(author.company_id > 917) 이면서 registerType != 사내담당자
    //   (스펙상 != 는 registerType 값이 없는 회원도 포함하므로, registerType 미설정 회원은 사외로 취급된다)
    const authorConditions = [];
    const writerType = search.writerType && search.writerType.length > 0 ? search.writerType[0] : "";
    if (writerType === "직영") {
      conditions.push({ key: "author.company_id", operator: "IN", value: 직영업체Ids });
    } else if (writerType === "사내수급") {
      conditions.push({ key: "author.company_id", operator: ">", value: 직영업체MaxId });
      authorConditions.push({ key: "registerType", operator: "=", value: 사내담당자 });
    } else if (writerType === "사외수급") {
      conditions.push({ key: "author.company_id", operator: ">", value: 직영업체MaxId });
      authorConditions.push({ key: "registerType", operator: "!=", value: 사내담당자 });
    }
    nav.authorConditions = authorConditions;

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "작업명",
        key: "body.TBM정보.작업명",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "TBM 실시일",
        key: "body.TBM정보.TBM실시일",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "폭염작업여부",
        key: "body.TBM정보.폭염작업여부",
      },
      {
        name: "상태",
        key: "",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 6) {
          const 폭염작업여부 = func.getContent(value).TBM정보.폭염작업여부;
          if (폭염작업여부) {
            return 폭염작업여부;
          } else {
            return "N";
          }
        } else if (index === 7) {
          const body = func.getContent(value);
          const 참석자명단 = body.참석자명단;
          const 사진대지 = body.photoList.filter((e) => e.id);
          const TBM실시시간 = body.TBM정보.TBM실시시간;

          if (참석자명단.length === 0 || 사진대지.length === 0 || !TBM실시시간.eTime) {
            return { type: "html", html: `<span style="color:#EA5455">미진행</span>`, color: "#EA5455", text: "미진행" };
          } else {
            return { type: "html", html: `<span style="color:#28C76F">완료</span>`, color: "#28C76F", text: "완료" };
          }
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
